module.exports = __webpack_public_path__ + "img/favicon.c3f62c3a.png";